export default class PaginationDetailsModel {

    constructor(from, to, total, currentPage, firstPage, nextPage, previousPage, lastPage)
    {
        this.from = from;
        this.to = to;
        this.total = total;
        this.currentPage = currentPage;
        this.firstPage = firstPage;
        this.nextPage = nextPage;
        this.previousPage = previousPage;
        this.lastPage = lastPage;
    }

}
